import { ChangeEvent, FC, ReactNode } from "react"
import TextInput from "@/components/shared/TextInput"

interface CellProps {
   name: string
   value: string
   isEditMode: boolean
   className?: string
   readonly?: boolean
   children: ReactNode
   placeholder?: string
   error?: boolean
   handleCellChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const Cell: FC<CellProps> = ({
   name,
   value,
   isEditMode,
   className,
   readonly = false,
   children,
   placeholder = "",
   error = false,
   handleCellChange = () => {},
}) => {
   return isEditMode && !readonly ? (
      <TextInput
         {...(className && { className: className })}
         placeholder={placeholder}
         type={typeof value === "number" ? "number" : "text"}
         name={name}
         value={value}
         onChange={(e) => {
            handleCellChange(e)
         }}
         error={error}
      />
   ) : (
      children
   )
}

export default Cell
